import { render, staticRenderFns } from "./CampaignsEdit.vue?vue&type=template&id=217a88e8&scoped=true&"
import script from "./CampaignsEdit.vue?vue&type=script&lang=js&"
export * from "./CampaignsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsEdit.vue?vue&type=style&index=0&id=217a88e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a88e8",
  null
  
)

export default component.exports